import * as firestoreRedux from '@dreamworld/firestore-redux';

/**
 * Returns `AiChatAttachment` document from Firestore for the given attachment ID.
 * Called by `chip-item` when the `id` has an `aca_` prefix.
 * @param {Object} state Redux state
 * @param {String} attachmentId Attachment ID (e.g., `aca_xxx`)
 * @returns {Object|undefined} AiChatAttachment document
 */
export const attachment = (state, attachmentId) => {
  return firestoreRedux.selectors.doc(state, 'ai-chat-attachments', attachmentId);
};

/**
 * Given a references array, counts FILE refs by upload status.
 * Defaults to 'IN_PROGRESS' for attachments not yet in Redux (e.g., chip just inserted).
 * @param {Object} state Redux state
 * @param {Array<{type: string, id: string}>} refs
 * @returns {{ uploading: number, failed: number, canceled: number, success: number }}
 */
export const selectFileStatusCounts = (state, refs) => {
  const counts = { uploading: 0, failed: 0, canceled: 0, success: 0 };
  for (const ref of refs) {
    // Only AI Helper uploads (`aca_`) upload; a file referenced from a board (`ba_`/`ca_`) has no
    // upload doc and would otherwise count as uploading for ever, holding the message back.
    if (ref.type !== 'FILE' || !ref.id?.startsWith('aca_')) continue;
    const status = attachment(state, ref.id)?.status ?? 'IN_PROGRESS';
    if (status === 'IN_PROGRESS') counts.uploading++;
    else if (status === 'FAILED') counts.failed++;
    else if (status === 'CANCELED') counts.canceled++;
    else if (status === 'SUCCESS') counts.success++;
  }
  return counts;
};
